import { motion } from "framer-motion";
import { PDI_TOOLS, IMAGES } from "@/data/content";
import { SectionEyebrow } from "@/components/Marquee";

export default function PDIToolkit() {
  return (
    <section id="pdi" className="relative py-20 md:py-28 bg-void" data-testid="pdi-section">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10">
        <SectionEyebrow n="Ch. X" testId="pdi-eyebrow">The Toolkit</SectionEyebrow>
        <motion.h2
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 1, ease: [0.8, 0, 0.2, 1] }}
          className="mt-6 font-serif text-white text-5xl sm:text-6xl md:text-7xl leading-[0.98] tracking-tight max-w-4xl"
        >
          The PDI arsenal <span className="italic gradient-text">dealers hate.</span>
        </motion.h2>
        <p className="mt-4 text-lg text-silver/70 max-w-2xl">
          Negotiation gets you the deal. <span className="text-white">PDI helps protect it.</span>
        </p>

        <div className="mt-8 rounded-2xl border border-white/10 bg-surface p-6 md:p-7 flex flex-col md:flex-row md:items-center gap-4 md:gap-6" data-testid="pdi-online-tool-note">
          <div className="eyebrow gradient-text whitespace-nowrap">Available Now</div>
          <p className="text-silver/80 text-sm md:text-base leading-relaxed">
            Our <span className="text-white font-medium">Online PDI Tool</span> — a 60+ point, advisor-guided remote inspection portal — is live today, so you get a rigorous pre-delivery check even before in-person PDI rolls out. Upload photos checkpoint-by-checkpoint, get advisor sign-off, and receive a branded PDI report.
          </p>
        </div>

        <div className="mt-16 grid md:grid-cols-12 gap-6">
          <motion.div
            initial={{ opacity: 0, scale: 1.02 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 1.1, ease: [0.8, 0, 0.2, 1] }}
            className="md:col-span-5 relative rounded-3xl overflow-hidden border border-white/10 h-80 md:h-auto"
          >
            <img src={IMAGES.pdi} alt="Inspection tools" className="absolute inset-0 h-full w-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-tr from-void/95 via-void/40 to-transparent" />
            <div className="absolute bottom-6 left-6 right-6">
              <p className="eyebrow gradient-text">Field-proven</p>
              <p className="mt-2 font-serif text-3xl md:text-4xl text-white leading-tight">
                Six instruments. Zero blind spots.
              </p>
            </div>
          </motion.div>
          <div className="md:col-span-7 grid sm:grid-cols-2 gap-4">
            {PDI_TOOLS.map((t, i) => (
              <motion.div
                key={t.name}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-40px" }}
                transition={{ duration: 0.7, delay: i * 0.06 }}
                className="rounded-2xl border border-white/5 bg-surface p-6 hover:border-white/15 transition-colors"
                data-testid={`pdi-tool-${i}`}
              >
                <div className="font-serif text-xl text-white leading-tight">{t.name}</div>
                <div className="mt-2 text-sm text-silver/70 leading-relaxed">{t.body}</div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
